import { FunctionComponent } from 'react';
import InsightPickWrapper from './insightPick.style';
import PickType from '../../types/pick';

type InsightPickType = {
  pick: PickType;
};
const InsightPick: FunctionComponent<InsightPickType> = ({ pick }) => {
  return (
    <InsightPickWrapper image={pick.titleImageUrl}>
      <div className="insightpick--image" />
      <div className="insightpick--content-wrap">
        <p className="insightpick--subtitle">주목할 만한 콘텐츠</p>
        <p className="insightpick--title">{pick.title}</p>
        <p className="insightpick--description">{pick.plainContents}</p>
        <div className="insightpick--tags">
          {pick.tags.map((tag, index) => (
            <p className="insightpick--tag" key={index}>
              #{tag}
            </p>
          ))}
        </div>
      </div>
    </InsightPickWrapper>
  );
};

export default InsightPick;
